export const ONBOARDING_DRAFT_STORAGE_PREFIX =
  'lessor-first-run-onboarding-draft';

export const getOnboardingDraftKey = (userId: number) =>
  `${ONBOARDING_DRAFT_STORAGE_PREFIX}:${userId}`;

export const clearAllOnboardingDrafts = () => {
  if (typeof localStorage === 'undefined') return;

  try {
    const keysToRemove = Array.from(
      { length: localStorage.length },
      (_, index) => localStorage.key(index),
    ).filter((key): key is string =>
      Boolean(key?.startsWith(`${ONBOARDING_DRAFT_STORAGE_PREFIX}:`)),
    );

    keysToRemove.forEach((key) => localStorage.removeItem(key));
  } catch {
    // Logout cleanup is best-effort when storage is unavailable.
  }
};
